import "../HomeSecond/HomeSecond.css"
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IMG_URL } from '../../config';

function HomeSecond({HomeBanner}) {

    const HomeData =  HomeBanner;

    return (
        <div>

            <div className="home-second-div">

                <div className="container">

                    <div className="row">

                    </div>

                    <div className="row home-second-row">

                        <div className="col-12 col-sm-12 col-md-8 col-lg-8">

                            { HomeData?.maintitle &&

                                <div className="home-second-box1">

                                    <h3>

                                        {HomeData?.maintitle}

                                    </h3>

                                    <p>  {HomeData?.subline}</p>

                                </div>
                            }

                            <div className="home-second-box2">



                                { HomeData?.subtitle1 &&

                                    <div className="home2-sub1">

                                        <p>{HomeData?.subtitle1}</p>

                                        <a className='home2-sub1-a1' href="">

                                            <span className='home2-sub1-sp3'>
                                                <FontAwesomeIcon icon={faArrowRight} />
                                            </span>
                                        </a>

                                    </div>
                                }


                                { HomeData?.subtitle2 &&
                                    <div className="home2-sub1">
                                       
                                       <p>{HomeData?.subtitle2}</p>

                                        <a className='home2-sub1-a1' href="">

                                            <span className='home2-sub1-sp3'>
                                                <FontAwesomeIcon icon={faArrowRight} />
                                            </span>
                                        </a>

                                    </div>
                                }

                                { HomeData?.subtitle3 &&

                                    <div className="home2-sub1">
                                   
                                        <p>{HomeData?.subtitle3}</p>

                                        <a className='home2-sub1-a1' href="">

                                            <span className='home2-sub1-sp3'>
                                                <FontAwesomeIcon icon={faArrowRight} />
                                            </span>
                                        </a>

                                    </div>
                                }

                                
                                { HomeData?.subtitle4 &&

                                    <div className="home2-sub1">

                                        <p>{HomeData?.subtitle4}</p>

                                        <a className='home2-sub1-a1' href="">

                                            <span className='home2-sub1-sp3'>
                                                <FontAwesomeIcon icon={faArrowRight} />
                                            </span>
                                        </a>

                                    </div>
                                }

                                { HomeData?.subtitle5 &&

                                    <div className="home2-sub1">

                                        <p>{HomeData?.subtitle5}</p>

                                        <a className='home2-sub1-a1' href="">

                                            <span className='home2-sub1-sp3'>
                                                <FontAwesomeIcon icon={faArrowRight} />
                                            </span>
                                        </a>

                                    </div>
                                }



                            </div>


                            { HomeData?.learnbuttonname &&

                                <a className='home2-a' href={HomeData?.learnbuttonlink}>
                                    <span className='home2-sp1'>{HomeData?.learnbuttonname}</span>
                                    <span className='home2-sp3'>
                                        <FontAwesomeIcon icon={faArrowRight} />
                                    </span>
                                </a>
                            }


                        </div>


                        { HomeData?.previewimage &&
                            <div className="col-12 col-sm-12 col-md-4 col-lg-4">

                                <div className="home-second-img">

                                    <img loading="eager"  fetchPriority="high" decoding="async" src={`${IMG_URL}/d0/${HomeData?.previewimage}`} alt={HomeData?.upload_image_alt} />
                                </div>

                            </div>
                        }

                    </div>

                </div>

            </div>


        </div>
    )
}

export default HomeSecond